import React, { useState } from "react";
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "react-stripe-elements";
import Spinner from "react-bootstrap/Spinner";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addPaymentMethod } from "../../../../../api/payment_methods";
// import { subscribeToPrimoError, updateCurrentUser } from "../../../../../api/users";
import { updatePaymentMethod, updateCurrentUser } from "../../../../../api/payment_methods";
import { updateCurrentUserRedux } from "../../../../../api/helper";

const style = {
  base: {
    color: "#1a1a1a",
    fontFamily: '"Noir Pro", sans-serif',
    fontWeight: 500,
    fontSmoothing: "antialiased",
    fontSize: "16px",
    lineHeight: "21px",
    "::placeholder": {
      color: "#dadada",
      fontFamily: '"Noir Pro", sans-serif',
      fontWeight: 500,
      fontsize: "16px",
      lineheight: "21px",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
  },
};

const PrimoCheckoutForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required(),
      last_name: Yup.string().required(),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        setError(null);
        let { paymentMethod } = await props.stripe.createPaymentMethod({
          card: props.elements.getElement("cardNumber"),
          type: "card",
          billing_details: {
            name: values.first_name + " " + values.last_name,
          },
        });
        let {
          data: {
            payment_method: { payment_method_id },
          },
        } = await updatePaymentMethod({
          payment_method_id: paymentMethod.id,
          object: paymentMethod,
        });
        console.log("id", paymentMethod.id)
        props.onCheckoutDone();
      } catch (error) {
        console.log("error => ", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <form onSubmit={handleSubmit}>
      <div className="intro">

      </div>
      <h3 className="text-green">Update Billing Information</h3>
      <small>Modified credit card Detail</small>
      <div className="row mt-4">
        {error && (
          <div className="col-100 mb-3">
            <small className="text-danger">
              There was an error, Please make sure to enter a valid card details
              or please try again
            </small>
          </div>
        )}
        <div className="col">
          <input
            onChange={handleChange}
            value={values.first_name}
            name="first_name"
            placeholder="First Name"
            className={`form-control ${errors.first_name ? "error" : ""}`}
          />
        </div>
        <div className="col">
          <input
            onChange={handleChange}
            value={values.last_name}
            name="last_name"
            placeholder="Last Name"
            className={`form-control ${errors.last_name ? "error" : ""}`}
          />
        </div>
      </div>

      <div className="row my-3">
        <div className="col-50">
          <CardNumberElement style={style} placeholder="Card Number" />
        </div>
        <div className="col-30">
          <CardExpiryElement style={style} />
        </div>
        <div className="col-20">
          <CardCvcElement style={style} />
        </div>
      </div>
      <button
        disabled={loading}
        className="my-3 text-uppercase btn btn-lg btn-primary"
        type="submit"
      >
        {loading ? (
          <Spinner animation="border" variant="light" size="sm" role="status" />
        ) : (
          "Update"
        )}
      </button>
    </form>
  );
};

export default injectStripe(PrimoCheckoutForm);
